module.exports = __webpack_public_path__ + "img/Exhibition_Logo.2f0b8f95.jpg";